function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".settings-svg-a{fill:none;}.settings-svg-b{fill:#686868;}"));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "settings-svg-a",
  d: "M0,0H24V24H0Z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  className: "settings-svg-b",
  d: "M31.733,25.267a7.976,7.976,0,0,0,.082-1.006,5.4,5.4,0,0,0-.082-1.006l2.175-1.7a.533.533,0,0,0,.123-.657l-2.052-3.551a.521.521,0,0,0-.636-.226L28.8,18.146a7.021,7.021,0,0,0-1.744-1.006l-.39-2.709A.49.49,0,0,0,26.171,14h-4.1a.527.527,0,0,0-.513.431l-.39,2.709a8.2,8.2,0,0,0-1.744,1.006L16.874,17.12a.538.538,0,0,0-.636.226L14.186,20.9a.508.508,0,0,0,.123.657l2.175,1.7a8.244,8.244,0,0,0,0,2.011l-2.175,1.7a.533.533,0,0,0-.123.657l2.052,3.551a.521.521,0,0,0,.636.226l2.545-1.026a7.021,7.021,0,0,0,1.744,1.006l.39,2.709a.511.511,0,0,0,.513.431h4.1a.527.527,0,0,0,.513-.431l.39-2.709A7.586,7.586,0,0,0,28.8,30.378L31.364,31.4A.538.538,0,0,0,32,31.178l2.052-3.551a.533.533,0,0,0-.123-.657ZM24.119,27.34A3.079,3.079,0,1,1,27.2,24.262,3.074,3.074,0,0,1,24.119,27.34Z",
  transform: "translate(-12.116 -12)"
});

function SvgSettings(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettings);
export default __webpack_public_path__ + "static/media/settings.78b31dfb.svg";
export { ForwardRef as ReactComponent };